import {
  FETCH_PERMISSIONS_FAILED,
  FETCH_PERMISSIONS_REQUEST,
  FETCH_PERMISSIONS_SUCCESS,
  UPDATE_PERMISSIONS,
} from './actionCreator';

const initialState = {
  permissions: {},
  loading: false,
  error: null,
};

const permissionsReducers = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PERMISSIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_PERMISSIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        permissions: action.payload,
        error: null,
      };
    case FETCH_PERMISSIONS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case UPDATE_PERMISSIONS:
      return { ...state, permissions: action.payload };
    default:
      return state;
  }
};

export default permissionsReducers;
